/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KeyValuePair } from './keyValuePair';


export interface DisconnectedComponent { 
    /**
     * Component Id
     */
    component_id?: string;
    /**
     * Type of component
     */
    component_type?: string;
    /**
     * Resource FQDN
     */
    fqdn?: string;
    metadata?: Array<KeyValuePair>;
    /**
     * Name of component
     */
    name?: string;
    srm_version?: string;
    /**
     * Id for vcenter
     */
    vcenter_id?: string;
}

